<template>
  <div
    :style="style"
    :class="[
      'style-icon-container scss-click-effect',
      cssClass,
    ]"
  >
    <i
      :class="[
        'bi',
        iconClass,
      ]"
      :style="iconStyle"
    />
  </div>
</template>

<script>
export default {
  name: "IconContainer",
  props: {
    cssClass: String,
    style: String,
    iconClass: {
      type: String,
      default: 'bi-bootstrap',
    },
    iconStyle: String,
  },
};
</script>

<style lang="scss" scoped>
.style-icon-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style-icon-container:active {
  transition: 0.2s;
  opacity: 0.8;
  background-color: $button-blue;
}
.style-border {
  border: 2px solid $blue;
  color: $blue;
}
</style>
